import { render, staticRenderFns } from "./GraficoSexo.vue?vue&type=template&id=870340a8&"
import script from "./GraficoSexo.vue?vue&type=script&lang=js&"
export * from "./GraficoSexo.vue?vue&type=script&lang=js&"
import style0 from "./GraficoSexo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports